import { EvPlugCcs1Icon } from './EvPlugCcs1Icon';

/**
 * author: Michael Irigoyen
 * id 7C687673-B2F0-43B6-A5E3-E25B9FFA0F8E
 * name ev-plug-ccs1
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ev-plug-ccs1.svg
 * tags
 * - Automotive 
 */
export const EvPlugCcsCombo1Icon = EvPlugCcs1Icon;
export default EvPlugCcsCombo1Icon